'use strict'

import format from 'string-format'

import axios from 'axios'

import {obj_to_FormData} from "../../../api/utils";

const CSRF_COOKIE_NAME = 'csrftoken';
const CSRF_HEADER_NAME = 'X-CSRFToken';


export default class AmpliVarStatApi {

	constructor(subsite) {
		this._subsite = subsite
	}

	get session() {
		if (!this._session) {
			this._session = axios.create({
				baseURL: this._subsite + 'AmpliVarStat/PgmToolsRest/v1',
				xsrfCookieName: CSRF_COOKIE_NAME,
				xsrfHeaderName: CSRF_HEADER_NAME,
				withCredentials: true,
				Accept: 'application/json; indent=2',
			})
		}
		return this._session
	}

	analysis_list() {
		return this.session.request({
			method: 'GET',
			url: format('analysis/'),
		})
			.catch((error) => {
				console.error(format(
					"method: '{method}', url: '{url}'\n" +
					"error: '{error}'.",
					{
						method: error.config.method,
						url: error.config.url,
						error: error.toString()
					}))
				throw error
			})
	}

	analysis_create(analysis, details) {
		// TODO: details не используется
		let data = obj_to_FormData(analysis)
		return this.session.request({
			method: 'POST', // https://www.restapitutorial.com/lessons/httpmethods.html
			url: format('analysis/'),
			headers: {'Content-Type': 'multipart/form-data',},
			data
		})
			.catch((error) => {
				console.error(format(
					"method: '{method}', url: '{url}'\n" +
					"error: '{error}'.",
					{
						method: error.config.method,
						url: error.config.url,
						error: error.toString()
					}))
				throw error
			})
	}

	analysis_update(analysis, details) {
		// TODO: details не используется
		let data = obj_to_FormData(analysis)
		return this.session.request({
			method: 'PATCH', // https://www.restapitutorial.com/lessons/httpmethods.html
			url: format('analysis/{id}/', {id: analysis.id}),
			headers: {'Content-Type': 'multipart/form-data',},
			data
		})
	}

	analysis_run(analysis_id, details) {
		return this.session.request({
			method: 'POST', //
			url: format('analysis/{id}/run/', {id: analysis_id}),
			headers: {'Content-Type': 'multipart/form-data',},
		})
	}
}
